import { type SearchInfoType } from "../profile/search";
import { type UserInfoType } from "../profile/user-info";
import { type MetaType } from "./common";

export enum UserStatusType {
  INACTIVE = "inactive",
  ACTIVE = "active",
  DELETE = "delete",
}

interface UserListResponse {
  users: UserInfoType[];
  meta: MetaType;
}

interface SearchItemListResponse {
  data: SearchInfoType[];
  meta: MetaType;
}

export type { UserListResponse, SearchItemListResponse };
